import { EventOutcomeType, EventTriggerType } from '@marvelapp/core';
import { makeEvent, resetTimestamp } from './events';
export function missedClick(_a) {
    var id = _a.id, height = _a.height, width = _a.width, coords = _a.coords, timestamp = _a.timestamp;
    var event = {
        trigger: {
            type: EventTriggerType.Tap,
            coords: coords,
        },
        object: {
            type: 'screen',
            id: id,
            height: height,
            width: width,
        },
        outcome: {
            type: EventOutcomeType.Miss,
        },
    };
    return makeEvent(event, timestamp);
}
export function startRecording() {
    var event = {
        trigger: {
            type: 'player',
        },
        object: {
            type: 'player',
        },
        outcome: {
            type: EventOutcomeType.StartRecording,
        },
    };
    return makeEvent(event);
}
export function initialScreen(_a) {
    var id = _a.id;
    var event = {
        trigger: {
            type: 'player',
        },
        object: {
            type: 'player',
        },
        outcome: {
            type: EventOutcomeType.ScreenTransition,
            scrollPosition: [0, 0],
            screen: id,
            animation: null,
            reverseAnimation: false,
        },
    };
    return makeEvent(event);
}
export function goalScreen(_a) {
    var id = _a.id, width = _a.width, height = _a.height;
    var event = {
        trigger: {
            type: 'player',
        },
        object: {
            type: 'screen',
            id: id,
            width: width,
            height: height,
        },
        outcome: {
            type: EventOutcomeType.GoalReached,
        },
    };
    return makeEvent(event);
}
export function stopRecording() {
    var event = {
        trigger: {
            type: 'player',
        },
        object: {
            type: 'player',
        },
        outcome: {
            type: EventOutcomeType.StopRecording,
        },
    };
    var fullEvent = makeEvent(event);
    resetTimestamp();
    return fullEvent;
}
export function screenTransition(_a) {
    var newScreenId = _a.newScreenId, hotspot = _a.hotspot;
    var trigger = { type: 'navigation' };
    var object = { type: 'player' };
    if (hotspot) {
        var id = hotspot.id, mouseCoords = hotspot.mouseCoords;
        trigger = { type: EventTriggerType.Tap, coords: mouseCoords };
        object = {
            type: 'hotspot',
            id: id,
        };
    }
    var event = {
        trigger: trigger,
        object: object,
        outcome: {
            type: EventOutcomeType.ScreenTransition,
            screen: newScreenId,
            scrollPosition: [0, 0],
            animation: null,
            reverseAnimation: false,
        },
    };
    return makeEvent(event);
}
export function interactiveChangeEvent(_a) {
    var newScreenId = _a.newScreenId, hotspot = _a.hotspot;
    // TODO: interactive click should have its own event in our event schema
    var trigger = { type: 'navigation' };
    var object = { type: 'player' };
    if (hotspot) {
        var id = hotspot.id, mouseCoords = hotspot.mouseCoords;
        trigger = { type: EventTriggerType.Tap, coords: mouseCoords };
        object = {
            type: 'hotspot',
            id: id,
        };
    }
    var event = {
        trigger: trigger,
        object: object,
        outcome: {
            type: EventOutcomeType.ScreenTransition,
            screen: newScreenId,
            scrollPosition: [0, 0],
            animation: null,
            reverseAnimation: false,
        },
    };
    return makeEvent(event);
}
